import { render } from "./ChatBotAiContextEditorCmp.vue?vue&type=template&id=65f6cfaa"
import script from "./ChatBotAiContextEditorCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotAiContextEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__